/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://cspr059zi2.execute-api.us-east-1.amazonaws.com/main",
            "region": "us-east-1"
        },
        {
            "name": "fgnapi",
            "endpoint": "https://xq5g6x1lrj.execute-api.us-east-1.amazonaws.com/main",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://nqebrqtkmjhpvj5zj6jgkim6qu.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-vidnt7ndpvbbnb2b5mpjhmsfhm",
    "aws_cognito_identity_pool_id": "us-east-1:8536e7ed-dae2-4074-944a-7b0fed5156bd",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_l5zJ4VuFb",
    "aws_user_pools_web_client_id": "5hna3tm4cq0nv2tsj5jmhplinu",
    "oauth": {
        "domain": "fgn6c984e36-6c984e36-main.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/oauthlogin/,http://localhost:3000/oauthlogin/",
        "redirectSignOut": "http://localhost:3000/oauthlogout/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "fgnstorage110703-main",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
